<div class="container">
    <div class="row w-100 mx-0 auth-page">
        <div class="col-md-6 col-xl-4 mx-auto">
            <div class="card">
                <div class="row">
                    <div class="col-md-12 ps-md-0">
                        <div class="auth-form-wrapper px-4 py-5">
                            <a routerLink="."
                                class="nobleui-logo d-block mb-2">TotalCare<span>&nbsp;{{environmentName}}</span></a>
                            <h5 class="text-secondary fw-normal mb-4">{{ 'MFA.SETUP.TITLE' | translate }}</h5>

                            <div>
                                <div *ngIf="errors && errors.length > 0" class=" alert alert-danger" role="alert">
                                    <div><strong>{{ 'MFA.SETUP.FOUTMELDING' | translate }}</strong></div>
                                    <div *ngFor="let error of errors">{{ error }}</div>
                                    <button (click)="backToLogin()" type="submit"
                                        class="btn btn-primary me-2 mb-2 mb-md-0 mt-2">{{ 'MFA.SETUP.TERUGNAARINLOGGEN'
                                        | translate }}</button>
                                </div>

                                <div class="mfa-setup" *ngIf="errors.length == 0">
                                    <div *ngIf="step === 1">
                                        <p>{{ 'MFA.SETUP.INSTRUCTIES' | translate }}</p>
                                        <qrcode *ngIf="!!qrCodeData" [qrdata]="qrCodeData" [width]="256"
                                            [errorCorrectionLevel]="'M'">
                                        </qrcode>
                                        <p>{{ 'MFA.SETUP.INSTRUCTIE_HANDMATIG' | translate }}:
                                            <code>{{ secretKey }}</code>
                                        </p>
                                        <button (click)="goToStepTwo()" type="submit"
                                            class="btn btn-primary me-2 mb-2 mb-md-0">{{ 'MFA.SETUP.BUTTON.VOLGENDE' |
                                            translate }}</button>
                                    </div>
                                    <div *ngIf="step === 2">
                                        <p>{{ 'MFA.SETUP.VUL_CODE_IN' | translate }}</p>

                                        <div class="mfa-container mb-3" [class.disabled]="isVerifying">
                                            <input *ngFor="let box of boxes; let i = index" maxlength="1" type="text"
                                                class="mfa-input" pattern="[0-9]*" inputmode="numeric" #codeBox
                                                (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)"
                                                (paste)="onPaste($event)" [id]="'mfa-' + i"
                                                autocomplete="one-time-code">
                                            <div class="loader-overlay" *ngIf="isVerifying">
                                                <div class="spinner-mfa"></div>
                                                <p>{{ 'MFA.SETUP.VALIDEREN' | translate }}</p>
                                            </div>
                                        </div>


                                        <p *ngIf="verifyError" class=" alert alert-danger" role="alert">{{ verifyError
                                            }}</p>

                                    </div>
                                    <div *ngIf="step === 3">
                                        <p>{{ 'MFA.SETUP.DANKJEWEL' | translate }}</p>
                                        <p>{{ 'MFA.SETUP.HERSTELCODES_UITLEG' | translate }}</p>
                                        <div class="recovery-codes">
                                            <div *ngFor="let code of recoveryCodes" class="code-box">
                                                {{ code }}
                                            </div>
                                            <button class="btn btn-primary mt-3" (click)="backToLogin()">
                                                {{ 'MFA.SETUP.TERUGNAARINLOGGEN' | translate }}
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>